import { api } from "./api";

export const GET_ALL_VEHICLES_CATEGORIES = async () => {
    const { data } = await api.get("/vehicles_categories")
    return data.vehiclesCategories || [];
}

export const GET_VEHICLE_CATEGORY = async (id: string) => {
    const { data } = await api.get(`/vehicles_categories/${id}`)
    return data;
}

export const DELETE_VEHICLE_CATEGORY = async (id: string) => {
    const { data } = await api.delete(`/vehicles_categories/${id}`)
    return data;
}

export const CREATE_VEHICLE_CATEGORY = async (params: any) => {
    const { data } = await api.post(`/vehicles_categories`, params)
    return data;
}

export const UPDATE_VEHICLE_CATEGORY = async (id: string, params: any) => {
    const { data } = await api.patch(`/vehicles_categories/${id}`, params)
    return data;
}

